<template>
  <div class="p-4">
    <h3 class="text-5xl font-bold mb-8">Proyectos</h3>
  </div>
  <template v-if="false"
    ><!-- getAllProjects -->
    <flickity ref="flickity" :options="flickityOptions" class="">
      <div
        class="carousel-cell"
        v-for="(project, index) in getAllProjects"
        :key="index"
      >
        <div class="card bg-base-100 shadow-2xl">
          <div class="card bg-base-100 shadow-2xl">
            <figure>
              <img :src="getCoverImage(project.image_project)" alt="Shoes" />
            </figure>
            <div class="card-body">
              <div class="card-actions justify-center">
                <div class="w-full">
                  <h2 class="card-title">{{ project.title }}</h2>
                </div>
                <!--  <p>
                  {{ project.description }}
                </p> -->
                <div class="card-actions mt-3 w-full">
                  <a
                    target="_blank"
                    :href="project.link_demo"
                    class="btn btn-primary w-full"
                    :class="project.link_demo ? '' : `btn-disabled`"
                  >
                    Demo
                    <PlayButtonIcon />
                  </a>
                  <!--  <div class="grid grid-cols-6"> -->
                  <!-- <div class="col-span-3">
                        <a
                          target="_blank"
                          :href="project.link_repository"
                          class="btn btn-outline"
                          :class="
                            project.link_repository || `btn-disabled`
                          "
                          >GitHub <GitHubIcon
                        /></a>
                      </div> -->
                  <!--   </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </flickity>
  </template>
  <template v-else>
    <div class="flex justify-center">
      <CardNotContent />
    </div>
  </template>
</template>

<script>
/* Getters */
import { mapGetters } from "vuex";

/* Icons */
/* import GitHubIcon from "@/assets/icons/gitHub.vue"; */
import PlayButtonIcon from "@/assets/icons/buttonPlay.vue";

/* Components */
import CardNotContent from "@/components/CardNotContent.vue";

import Flickity from "vue-flickity";

export default {
  name: "Card",
  inject: ["mq"],
  data() {
    return {
      flickityOptions: {
        prevNextButtons: false,
        groupCells: this.mq.current != "xxl" ? 1 : 3,
        pageDots: false,
        wrapAround: this.mq.current != "xxl" ? true : false,
      },
    };
  },
  components: {
    /*   GitHubIcon, */
    PlayButtonIcon,
    CardNotContent,
    Flickity,
  },
  methods: {
    next() {
      this.$refs.flickity.next();
    },

    previous() {
      this.$refs.flickity.previous();
    },

    getCoverImage(img) {
      return require(`@/assets/images/projects/${img}`);
    },
  },
  computed: {
    ...mapGetters(["getAllProjects"]),
  },
};
</script>

<style>
.flickity-viewport {
  height: 540px !important;
}
.carousel-cell {
  /* width: 30%; */ /* 90% en mobile */
  width: 20%;
  height: 520px;
  margin-right: 10px;

  border-radius: 5px;
}

@media only screen and (max-width: 768px) {
  .carousel-cell {
    /* width: 30%; */ /* 90% en mobile */
    width: 90%;
    height: 520px;
    margin-right: 10px;
    border-radius: 5px;
  }
  .flickity-viewport {
    height: 450px !important;
  }
}

/* cell number */
.carousel-cell:before {
  display: block;
  text-align: center;
  line-height: 200px;
  font-size: 80px;
  color: white;
}

/* smaller, dark, rounded square */
.flickity-button {
  background: #333;
}
.flickity-button:hover {
  background: #f90;
}

.flickity-prev-next-button {
  width: 50px;
  height: 50px;
  border-radius: 5px;
}
/* icon color */
.flickity-button-icon {
  fill: white;
}
/* position outside */
/* .flickity-prev-next-button.previous {
  left: -10px;
}
.flickity-prev-next-button.next {
  right: -10px;
} */
</style>